import { render, staticRenderFns } from "./ReductionPerformanceGraph.vue?vue&type=template&id=943fda30&scoped=true"
import script from "./ReductionPerformanceGraph.vue?vue&type=script&lang=js"
export * from "./ReductionPerformanceGraph.vue?vue&type=script&lang=js"
import style0 from "./ReductionPerformanceGraph.vue?vue&type=style&index=0&id=943fda30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943fda30",
  null
  
)

export default component.exports